if (!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider"]');
        this.sliderItems = this.slider ? this.slider.querySelectorAll('.slider__slide') : [];
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.currentIndex = 0;
        this.isScrolling = false;

        if (!this.slider || !this.nextButton) return;

        this.initPages();

        const resizeObserver = new ResizeObserver(() => this.initPages());
        resizeObserver.observe(this.slider);

        this.prevButton.addEventListener('click', () => this.goToIndex(this.currentIndex - 1));
        this.nextButton.addEventListener('click', () => this.goToIndex(this.currentIndex + 1));

        this.slider.addEventListener('scroll', this.onScroll.bind(this));
      }

      initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
          (element) => element.clientWidth > 0
        );
        this.totalPages = this.sliderItemsToShow.length;

        if (this.pageTotalElement) {
          this.pageTotalElement.textContent = this.totalPages;
        }

        this.updateCounter();
        this.updateButtons();
      }

      resetPages() {
        this.sliderItems = this.slider.querySelectorAll('.slider__slide');
        this.initPages();
      }

      goToIndex(index) {
        if (!this.sliderItemsToShow) return;

        const newIndex = Math.max(0, Math.min(index, this.totalPages - 1));
        const targetSlide = this.sliderItemsToShow[newIndex];
        if (!targetSlide) return;

        this.currentIndex = newIndex;
        this.isScrolling = true;
        clearTimeout(this.scrollTimeout);

        this.slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        this.updateCounter();
        this.updateButtons();

        if ('onscrollend' in this.slider) {
          this.slider.addEventListener('scrollend', () => {
            this.isScrolling = false;
          }, { once: true });
        } else {
          this.scrollTimeout = setTimeout(() => {
            this.isScrolling = false;
          }, 500);
        }
      }

      onScroll() {
        if (!this.sliderItemsToShow || this.isScrolling) return;

        const scrollCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;

        const closest = this.sliderItemsToShow.reduce((nearestIdx, slide, idx) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const prevSlide = this.sliderItemsToShow[nearestIdx];
          const prevCenter = prevSlide.offsetLeft + prevSlide.clientWidth / 2;
          return Math.abs(slideCenter - scrollCenter) < Math.abs(prevCenter - scrollCenter)
            ? idx
            : nearestIdx;
        }, 0);

        if (closest !== this.currentIndex) {
          this.currentIndex = closest;
          this.updateCounter();
          this.updateButtons();
        }
      }

      updateCounter() {
        if (this.currentPageElement) {
          this.currentPageElement.textContent = this.currentIndex + 1;
        }
      }

      updateButtons() {
        if (!this.enableSliderLooping) {
          if (this.prevButton) {
            this.currentIndex <= 0
              ? this.prevButton.setAttribute('disabled', 'disabled')
              : this.prevButton.removeAttribute('disabled');
          }
          if (this.nextButton) {
            this.currentIndex >= this.totalPages - 1
              ? this.nextButton.setAttribute('disabled', 'disabled')
              : this.nextButton.removeAttribute('disabled');
          }
        }
      }

      isSlideVisible(element, offset = 0) {
        const lastVisibleSlide =
          this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (
          element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
          element.offsetLeft >= this.slider.scrollLeft
        );
      }
    }
  );
}